import Swal from 'sweetalert2'

let Toast = null

/**
 * Initializes SweetAlert2 Toast mixin and registers the Unpoly compiler.
 */
export function registerToastCompiler() {
  if (!Toast) {
    Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3e3,
      width: 'auto',
      didOpen: (toast) => {
        const progress = document.createElement('div')
        Object.assign(progress.style, {
          position: 'absolute',
          bottom: '0',
          left: '0',
          width: '100%',
          height: '3px'
        })
        toast.appendChild(progress)

        let width = 100
        const interval = setInterval(() => {
          width -= 0.5
          progress.style.width = width + '%'
          if (width <= 0) {
            clearInterval(interval)
          }
        }, 15)

        const alertType = Array.from(toast.classList)
          .find((cls) => cls.startsWith('swal2-icon'))
          ?.replace('swal2-icon-', '')

        switch (alertType) {
          case 'success':
            progress.classList.add('bg-success')
            toast.classList.add('text-success')
            break
          case 'info':
            progress.classList.add('bg-info')
            toast.classList.add('text-info')
            break
          case 'warning':
            progress.classList.add('bg-warning')
            toast.classList.add('text-warning')
            break
          case 'error':
            progress.classList.add('bg-danger')
            toast.classList.add('text-danger')
            break
          default:
            progress.classList.add('bg-info')
            toast.classList.add('text-info')
        }
      }
    })
  }

  up.compiler('.toast', function (element, data) {
    Toast.fire(data)
  })
}

/**
 * Fires a toast notification programmatically.
 * @param {('success'|'info'|'warning'|'error')} icon
 * @param {string} title
 */
export function showToast(icon, title) {
  if (!Toast) registerToastCompiler()
  Toast.fire({ icon, title })
}

export default registerToastCompiler
